import React, { FC, useEffect } from "react";
import { Toast } from "react-bootstrap";
import { X } from "react-bootstrap-icons";

type Props = {
  isShow: boolean;
  setShow: (value: boolean) => void;
  message: string;
};
export const CustomToast: FC<Props> = ({ isShow, setShow, message }) => {
  const closeToast = () => {
    if (isShow) {
      setShow(false);
    }
  };

  useEffect(() => {
    if (isShow) {
      const timer = setTimeout(() => {
        setShow(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isShow, setShow]);

  return (
    <div
      className={`w-100 ${isShow ? "d-flex" : "d-none"} justify-content-center py-5 position-fixed bottom-0 z-2 translate-middle-x start-50`}
    >
      <Toast
        show={isShow}
        onClose={closeToast}
        className={`border-0 bg-dark`}
        style={{ width: "fit-content", boxShadow: "none" }}
      >
        <Toast.Body className="d-inline-flex align-items-center py-2 pe-2 ps-3">
          <p className={`mb-0 me-2 fs-6 text-white`}>{message}</p>
          <X className="text-white fs-5 cursor-pointer" onClick={closeToast} />
        </Toast.Body>
      </Toast>
    </div>
  );
};
